import React from "react";

const NotAuthorized = () => {
    return (
        <div>
            <h1>Not Authorized</h1>
            <p>You are not authorized to view this page.</p>
        </div>
    );
};

export default NotAuthorized;